var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"modal"},[_c('div',{staticClass:"overlay",on:{"click":function($event){return _vm.closeModal()}}}),_c('div',{staticClass:"content-wrapper modal-container"},[_vm._t("closeButton"),_c('div',{staticClass:"content",style:(_vm.contentStyle)},[_vm._t("body",function(){return [_vm._v(" no content ")]})],2)],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }